import { conversationSteps, buildSessionEndedMessage } from '../utils/conversationFlow';
import { saveConversationToStorage } from '../utils/storage';
import { completeAirtableSession } from '../utils/helpers';
import { replacePlaceholders, nextMessageId } from '../utils/aiResponseProcessor';

const RESTART_DELAY = 100;

const useSessionManagement = ({
  state,
  dispatch,
  setScrollPosition,
  onAmenitySelected,
  config,
}) => {
  const handleSessionEnd = () => {
    const endMessages = [
      { id: nextMessageId(), type: 'user', text: 'No' },
      buildSessionEndedMessage(config),
    ];

    dispatch({ type: 'END_SESSION', payload: endMessages });
    completeAirtableSession(state.sessionId, 'natural');

    if (onAmenitySelected) {
      onAmenitySelected(null);
    }
  };

  const handleRestartSession = () => {
    localStorage.removeItem(`chatbot_conversation_${state.sessionId}`);

    dispatch({ type: 'RESET_SESSION', payload: {} });
    setScrollPosition(0);

    if (onAmenitySelected) {
      onAmenitySelected(null);
    }

    const inputElement = document.querySelector('[data-tgai-input] textarea');
    if (inputElement) {
      inputElement.value = '';
    }

    setTimeout(() => {
      const welcomeStep = conversationSteps.welcome_form;
      if (welcomeStep) {
        const initialMessage = {
          id: nextMessageId(),
          type: 'bot',
          text: replacePlaceholders(welcomeStep.message, { selectedInterests: [], userInfo: {} }, config),
          instructions: welcomeStep.instructions || null,
          formFields: welcomeStep.formFields || null,
          submitButton: welcomeStep.submitButton || null,
          clearDataLink: welcomeStep.clearDataLink || null,
          stepType: welcomeStep.type,
        };

        dispatch({ type: 'SET_MESSAGES', payload: [initialMessage] });
        saveConversationToStorage(
          state.sessionId,
          [initialMessage],
          {
            currentStep: 'welcome_form',
            selectedInterests: [],
            selectedAmenities: [],
            visitedAmenities: [],
            userInfo: {
              firstName: '',
              lastName: '',
              email: '',
              phone: '',
              previousSession: false,
            },
            conversationData: {},
            formData: {},
            formErrors: {},
          },
          {},
          [],
        );
      }
    }, RESTART_DELAY);
  };

  return { handleSessionEnd, handleRestartSession };
};

export default useSessionManagement;
